import { ReactComponent as DeliveryIcon } from '@assets/images/app/icon-truck-normal.svg';
import { ReactComponent as MegaphoneIcon } from '@assets/images/app/icon-megaphone.svg';
import { ReactComponent as LocationIcon } from '@assets/images/app/icon-location.svg';
import { ReactComponent as ClockIcon } from '@assets/images/app/icon-clock.svg';
import { ReactComponent as ChildIcon } from '@assets/images/app/icon-child.svg';
import { ReactComponent as UsersIcon } from '@assets/images/app/icon-users.svg';
import { PRODUCT_ACTIVITY_TYPE_TEXT, ProductActivityType } from '@consts/products';
import { ProductModel } from '@models/product';
import { getAddressesText } from '@utils/dataTransform';
import React from 'react';
import { Divider } from './Divider';

export const ProductInformation: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;

  const activityType = data?.activityType || ProductActivityType.EXPERIENTIAL;
  const ActivityTypeIcon = PRODUCT_ACTIVITY_TYPE_TEXT[activityType]?.Icon;
  const displayStudentsSize = (data?.studentsMin ?? false) && (data?.studentsMax ?? false);

  return (
    <div style={{ padding: '24px 16px' }}>
      <div>
        {activityType === ProductActivityType.DELIVERY && (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}>
              <DeliveryIcon />
              <div
                style={{
                  fontSize: '18px',
                  lineHeight: '24px',
                  fontWeight: 500,
                  color: '#242424',
                }}>
                택배비
                {data?.shippingFee === 0 ? ` 무료` : ` ${(data?.shippingFee || 0).toLocaleString()}원`}
              </div>
            </div>
            <div style={{ marginLeft: '40px' }}>
              <div
                style={{
                  color: '#808387',
                  fontSize: '14px',
                  lineHeight: '21px',
                  marginTop: '4px',
                  whiteSpace: 'pre-wrap',
                }}>
                {data?.sellerShortComment}
              </div>
            </div>
          </>
        )}
        {data?.classDuration && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <ClockIcon stroke={'#808387'} style={{ width: '20px', height: '20px' }} />
            <div
              style={{
                color: 'var(--Neutral-90, #424242)',
                fontFamily: 'Pretendard',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 500,
                marginLeft: '12px',
              }}>
              {data?.classDuration}분
            </div>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: '16px',
          }}>
          <ActivityTypeIcon stroke={'#808387'} style={{ width: '20px', height: '20px' }} />
          <div
            style={{
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'row',
              marginLeft: '12px',
            }}>
            <div
              style={{
                color: 'var(--Neutral-90, #424242)',
                fontFamily: 'Pretendard',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 500,
              }}>
              {activityType && <div>{PRODUCT_ACTIVITY_TYPE_TEXT[activityType]?.title}</div>}
            </div>
          </div>
        </div>

        {[
          ProductActivityType.STUDIO,
          ProductActivityType.EXPERIENTIAL,
          ProductActivityType.HOME,
          ProductActivityType.TICKET,
        ].includes(activityType) &&
          data?.location &&
          getAddressesText({ availableArea: data?.location, activityType }) !== '-' && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: '16px',
                marginBottom: '4px',
                width: '100%',
                alignItems: 'flex-start',
              }}>
              <LocationIcon stroke={'#808387'} style={{ width: '20px', height: '20px' }} />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  marginLeft: '12px',
                }}>
                <div>
                  <div
                    style={{
                      color: 'var(--Neutral-90, #424242)',
                      fontFamily: 'Pretendard',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      whiteSpace: 'pre-wrap',
                    }}>
                    {getAddressesText({ availableArea: data?.location, activityType })}
                  </div>
                </div>
              </div>
            </div>
          )}
        {data?.ageMin > 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: '16px',
            }}>
            <ChildIcon stroke={'#808387'} style={{ width: '20px', height: '20px' }} />
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '12px' }}>
              <div>
                <div
                  style={{
                    color: 'var(--Neutral-90, #424242)',
                    fontFamily: 'Pretendard',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                  }}>
                  {`${data?.ageMin}세 ~ ${data?.ageMax > 13 ? '14세+' : `${data?.ageMax}세`}`}
                </div>
              </div>
            </div>
          </div>
        )}
        {displayStudentsSize && (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '16px' }}>
            <UsersIcon stroke={'#808387'} style={{ width: '20px', height: '20px' }} />
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '12px' }}>
              <div>
                <div
                  style={{
                    color: 'var(--Neutral-90, #424242)',
                    fontFamily: 'Pretendard',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                  }}>
                  {data?.studentsMin === -1
                    ? '인원 제한없음'
                    : `${data?.studentsMin}인 ~ ${
                        data?.studentsMax === -1 ? '인원 제한없음' : `${data?.studentsMax}인`
                      }`}
                </div>
              </div>
            </div>
          </div>
        )}
        {data.sellerComment && <Divider style={{ margin: '20px 0', padding: 0 }} />}
        {data.sellerComment && (
          <div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <MegaphoneIcon stroke={'#808387'} style={{ width: '20px', height: '20px' }} />
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '12px' }}>
                <div>
                  <div
                    style={{
                      color: 'var(--Neutral-90, #424242)',
                      fontFamily: 'Pretendard',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                    }}>
                    구매 안내
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginLeft: '36px' }}>
              <div
                style={{
                  color: 'var(--Neutral-70, #808387)',
                  fontFamily: 'Pretendard',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  whiteSpace: 'pre-wrap',
                  lineHeight: '20px',
                }}>
                {data?.sellerComment}
              </div>
            </div>
          </div>
        )}
      </div>
      {data?.tags && data?.tags.length > 0 && (
        <>
          <Divider style={{ margin: '20px 0', padding: 0 }} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              marginTop: '20px',
            }}>
            {data?.tags.slice(0, 2).map((item, index) => {
              return (
                <div
                  key={`tag-${index}`}
                  style={{
                    display: 'flex',
                    paddingLeft: '8px',
                    paddingRight: '8px',
                    borderRadius: '6px',
                    backgroundColor: '#eff1f4',
                    height: '28px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                  }}
                  onClick={() => {
                    // this.onSearchDone(item);
                  }}>
                  <div
                    style={{
                      color: 'var(--Neutral-70, #808387)',
                      fontFamily: 'Pretendard',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                    }}>
                    {item}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
